import { move } from '@dmp/shared/helpers';
import { isQuestionItem } from '../../state-type-guards';
import type { StoreState } from '../../state-types';
import { makeSurveyDirty } from '../utils/make-survey-dirty';

/**
 * Move an answer to a new index in a card.
 */
export const moveAnswer =
    (cardId: string, answerId: string, newIndex: number) =>
    (state: StoreState): StoreState => {
        const card = state.actions.getCard(cardId);
        if (!card) {
            throw new Error('Card not found');
        }

        // Ensure it's a question card
        if (!isQuestionItem(card)) {
            throw new Error('Only Question Cards can have Answers.');
        }

        const prevIndex = card.answerIds.indexOf(answerId);
        if (prevIndex === -1) {
            throw new Error('Answer not found');
        }

        // update moved answer ids in the card
        const newAnswerIds = moveToNewIndex(
            card.answerIds,
            prevIndex,
            newIndex
        );

        return makeSurveyDirty({
            ...state,
            cards: {
                ...state.cards,
                [cardId]: {
                    ...card,
                    answerIds: newAnswerIds,
                },
            },
        });
    };

const moveToNewIndex = (
    answerIds: string[],
    oldIndex: number,
    newIndex: number
): string[] => {
    // invalid when index < 0 or > array length
    const invalid =
        oldIndex < 0 ||
        newIndex < 0 ||
        oldIndex > answerIds.length ||
        newIndex > answerIds.length;

    return invalid ? answerIds : move(answerIds, oldIndex, newIndex);
};
